import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { GenrePage } from "./pages/GenrePage";
import "./index.css";

// 将来的に増えることを想定して、ジャンルリストを配列で管理
const genres = [
  { id: "巨乳", label: "巨乳" },
  // 将来的に以下のようなジャンルが追加される予定
  // { id: "爆乳", label: "爆乳" },
  // { id: "年下", label: "年下" },
  // { id: "年上", label: "年上" },
];

function HomePage() {
  return (
    <div className="container mx-auto p-8 text-center relative z-10">
      <Card className="bg-card/50 backdrop-blur-sm border-muted">
        <CardContent className="pt-6">
          <h1 className="text-4xl font-bold my-4 leading-tight">FANZA動画検索</h1>
          
          <div className="my-8">
            <h2 className="text-2xl font-semibold mb-4">ジャンルから選ぶ</h2>
            <div className="flex flex-wrap justify-center gap-4">
              {genres.map((genre) => (
                <Link key={genre.id} to={`/genre/${genre.id}`}>
                  <Button 
                    variant="secondary" 
                    size="lg"
                    className="min-w-32 text-lg"
                  >
                    {genre.label}
                  </Button>
                </Link>
              ))}
            </div>
          </div>
          
          <p className="text-sm text-gray-500 mt-8">
            ※ 今後、様々なジャンルが追加される予定です
          </p>
        </CardContent>
      </Card>
    </div>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/genre/:genre" element={<GenrePage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
